<button class="button" (click)="onClick()">
  <app-icon [icon]="icon()" colorCss="--replay-playback-icon-fill" sizeCss="--icon-x-large">
  </app-icon>
</button>
